/**
 * How long a party has been at a table.
 *
 * WHY IN WORDS RATHER THAN A TIMESTAMP
 * ------------------------------------
 * The floor is read at a glance by somebody carrying plates. "1h 40m" answers
 * the question; "19:22" makes them work out the answer, and they are holding
 * two plates.
 *
 * WHY THE NUMBER MATTERS AT ALL
 * -----------------------------
 * A table sitting ninety minutes is either a long lunch or a bill nobody has
 * taken over. Both want somebody to look, and neither shows up in the total.
 */
import { parseServerTime, minutesSince } from '@foodrun/shared';

/** Long enough that somebody should look. */
export const LINGERING_MINUTES = 90;

export function sittingFor(seatedAt, now = Date.now()) {
  const started = parseServerTime(seatedAt);
  if (!started) return null;

  const minutes = Math.max(0, Math.round((now - started.getTime()) / 60000));
  if (minutes < 60) return `${minutes} min`;

  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest ? `${hours}h ${rest}m` : `${hours}h`;
}

/** Whether a table has been sitting long enough to be worth a look. */
export function isLingering(seatedAt, now = Date.now()) {
  if (!seatedAt) return false;
  return (minutesSince(seatedAt, now) ?? 0) >= LINGERING_MINUTES;
}
